import React, { useMemo } from 'react';
import {
  Dropdown,
} from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { debounce } from 'lodash';
import { validationClasses } from '@/utils/errors';
import fields from '@/constants/fields';
import { cohortFilters } from '../constants';
import { mapStateToProps } from '../components/QueryFilterContainer';
import { updateQueryFilterOperator } from '../actions';
import { fetchClauseCounts } from '../../profile/actions';
import { refreshCohortVisualisation } from '../../visualisations/actions';
import { translatedOperator } from '../helper';

const listItems = (
  intl,
  value,
  type,
) => {
  const filters = cohortFilters[type];
  return (Object.keys(filters).map((operator) => ({
    key: `search_operator_dropdown_item_${operator}`,
    value: filters[operator],
    active: filters[operator] === value,
    ...translatedOperator(operator, intl),
  })));
};

const CohortFilterOperatorDropdown = ({
  category,
  code,
  type,
  operator,
  queryUUID,
  clauseUUID,
  filterUUID,
  updateOperator,
  fetchCounts,
  fetchVisualisation,
  saveErrors,
}) => {
  const intl = useIntl();
  const refreshCounts = useMemo(() => debounce(fetchCounts, 500), []);
  const refreshVisualisation = useMemo(() => debounce(fetchVisualisation, 700), []);

  const updateFilterOperator = (newOperator) => {
    updateOperator(category, code, queryUUID, clauseUUID, filterUUID, newOperator);
    refreshCounts(category, code, queryUUID, clauseUUID, true);
    refreshVisualisation(category, code, queryUUID);
  };

  const validationError = saveErrors.find((e) => (
    e.context.filterUUID === filterUUID && e.fields.includes(fields.OPERATOR)));

  return (
    <Dropdown
      className={validationClasses(validationError, 'aridhia-cohort-filter-operator-dropdown max-content')}
      options={listItems(intl, operator, type)}
      value={operator}
      selection
      fluid
      placeholder={intl.formatMessage({ id: 'table.filter.by.type.placeholder' })}
      onChange={(e, { value }) => updateFilterOperator(value)}
    />
  );
};

export const mapDispatchToProps = {
  updateOperator: updateQueryFilterOperator,
  fetchCounts: fetchClauseCounts,
  fetchVisualisation: refreshCohortVisualisation,
};

export default connect(mapStateToProps, mapDispatchToProps)(CohortFilterOperatorDropdown);
